<template>
<div>
<SelectEvent/>

</div>
</template>

<script>
import SelectEvent from "../../components/Event/SelectEvent.vue";


export default {
  components: {
   SelectEvent
  },
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  created() {

  },
  
};
</script>

<style scoped>


</style>